export function post_likes(state = { data: [] }, action) {
  if (action.type === 'GET_LIKES') {
    if (!action.reset) {
      if (action.data.length >= 1) {
        action.data.map(function(comments) {
          state.data.push(comments);
        });
      } else {
        state.data = [];
      }
    } else {
      state.data = action.data;
    }

    return {
      data: state.data,
      id_post: action.post_id,
      visible: action.visible
    };
  }
  return state;
}
